import { Capacitor } from '@capacitor/core';
import { URL_UTILS } from './url.utils';

export const ShareUtil = {
  getWhatsAppShareLink(input: string | string[]) {
    const whatsappShareMsg = Array.isArray(input) ? input.join('\n') : input;
    const baseURl = Capacitor.isNativePlatform() ? 'https://wa.me/?text=' : 'https://web.whatsapp.com/send?text=';
    return baseURl + URL_UTILS.encodeUrlQueryParamValue(whatsappShareMsg);
  },
};
